import * as Yup from 'yup'

export const projectEditValidationSchema = Yup.object().shape({
  sources: Yup.array().min(1),
  products: Yup.array(),
})
